import React from 'react';
import { createIntl, createIntlCache } from 'react-intl';
import { SearchPage } from './containers';

const cache = createIntlCache();

const messagesInLocale = require(`./translations/${process.env.REACT_APP_LANG || 'pl'}.json`)

const intl = createIntl(
  {
    locale: process.env.REACT_APP_LANG,
    messages: messagesInLocale,
  },
  cache
)

const categoryRoutesConfiguration = () => {
  return [
    {
      countries: ['pl', 'cz', 'hu'],
      key: 'wintersports_alpineskiing',
      path: intl.formatMessage({ id: 'urls.alpineskiingRent' }),
      name: 'AlpineSkiingSearchPage',
      component: props => <SearchPage
        categoryConfig={{
          header: intl.formatMessage({ id: 'SearchPage.alpineskiingHeader' }),
          description: intl.formatMessage({ id: 'SearchPage.alpineskiingDescription' }),
          metaTitle: intl.formatMessage({ id: 'SearchPage.alpineskiingMetaTitle' }),
          metaDescription: intl.formatMessage({ id: 'SearchPage.alpineskiingMetaDescription' }),
        }}
        pageName="AlpineSkiingSearchPage"
        {...props}
      />,
      loadData: (params, search) => SearchPage.loadData(params, search, 'wintersports_alpineskiing'),
    },
    {
      countries: ['pl', 'cz', 'hu', 'sk', 'lt'],
      key: 'bikes_gravel',
      path: intl.formatMessage({ id: 'urls.bikesGravelRent' }),
      name: 'GravelBikesSearchPage',
      component: props => <SearchPage
        categoryConfig={{
          header: intl.formatMessage({ id: 'SearchPage.bikesGravelHeader' }),
          description: intl.formatMessage({ id: 'SearchPage.bikesGravelDescription' }),
          metaTitle: intl.formatMessage({ id: 'SearchPage.bikesGravelMetaTitle' }),
          metaDescription: intl.formatMessage({ id: 'SearchPage.bikesGravelMetaDescription' }),
        }}
        pageName="GravelBikesSearchPage"
        {...props}
      />,
      loadData: (params, search) => SearchPage.loadData(params, search, 'bikes_gravel'),
    },
    {
      countries: ['pl', 'cz'],
      key: 'bikes_road',
      path: intl.formatMessage({ id: 'urls.bikesRoadRent' }),
      name: 'RoadBikesSearchPage',
      component: props => <SearchPage
        categoryConfig={{
          header: intl.formatMessage({ id: 'SearchPage.bikesRoadHeader' }),
          description: intl.formatMessage({ id: 'SearchPage.bikesRoadDescription' }),
          metaTitle: intl.formatMessage({ id: 'SearchPage.bikesRoadMetaTitle' }),
          metaDescription: intl.formatMessage({ id: 'SearchPage.bikesRoadMetaDescription' }),
        }}
        pageName="RoadBikesSearchPage"
        {...props}
      />,
      loadData: (params, search) => SearchPage.loadData(params, search, 'bikes_road'),
    },
    {
      countries: ['pl', 'cz'],
      key: 'bikes_trekking',
      path: intl.formatMessage({ id: 'urls.bikesTrekkingRent' }),
      name: 'TrekkingBikesSearchPage',
      component: props => <SearchPage
        categoryConfig={{
          header: intl.formatMessage({ id: 'SearchPage.bikesTrekkingHeader' }),
          description: intl.formatMessage({ id: 'SearchPage.bikesTrekkingDescription' }),
          metaTitle: intl.formatMessage({ id: 'SearchPage.bikesTrekkingMetaTitle' }),
          metaDescription: intl.formatMessage({ id: 'SearchPage.bikesTrekkingMetaDescription' }),
        }}
        pageName="TrekkingBikesSearchPage"
        {...props}
      />,
      loadData: (params, search) => SearchPage.loadData(params, search, 'bikes_trekking'),
    },
    {
      countries: ['pl', 'cz', 'sk', 'hu', 'lt'],
      key: 'bikes_electric',
      path: intl.formatMessage({ id: 'urls.bikesElectricRent' }),
      name: 'ElectricBikesSearchPage',
      component: props => <SearchPage
        categoryConfig={{
          header: intl.formatMessage({ id: 'SearchPage.bikesElectricHeader' }),
          description: intl.formatMessage({ id: 'SearchPage.bikesElectricDescription' }),
          metaTitle: intl.formatMessage({ id: 'SearchPage.bikesElectricMetaTitle' }),
          metaDescription: intl.formatMessage({ id: 'SearchPage.bikesElectricMetaDescription' }),
        }}
        pageName="ElectricBikesSearchPage"
        {...props}
      />,
      loadData: (params, search) => SearchPage.loadData(params, search, 'bikes_electric'),
    },
    {
      countries: ['pl', 'cz'],
      key: 'bikes_trailer',
      path: intl.formatMessage({ id: 'urls.bikesTrailerRent' }),
      name: 'BikesTrailerSearchPage',
      component: props => <SearchPage
        categoryConfig={{
          header: intl.formatMessage({ id: 'SearchPage.bikesTrailerHeader' }),
          description: intl.formatMessage({ id: 'SearchPage.bikesTrailerDescription' }),
          metaTitle: intl.formatMessage({ id: 'SearchPage.bikesTrailerMetaTitle' }),
          metaDescription: intl.formatMessage({ id: 'SearchPage.bikesTrailerMetaDescription' }),
        }}
        pageName="BikesTrailerSearchPage"
        {...props}
      />,
      loadData: (params, search) => SearchPage.loadData(params, search, 'bikes_trailer'),
    },
    {
      countries: ['pl', 'cz'],
      key: 'tourism_crampons',
      path: intl.formatMessage({ id: 'urls.tourismCramponsRent' }),
      name: 'TourismCramponsSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.tourismCramponsHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.tourismCramponsDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.tourismCramponsMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.tourismCramponsMetaDescription' }),
          }}
          pageName="TourismCramponsSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'tourism_crampons'),
    },
    {
      countries: ['pl', 'cz', 'hu'],
      key: 'wintersports_snowboard',
      path: intl.formatMessage({ id: 'urls.wintersportsSnowboardRent' }),
      name: 'WintersportsSnowboardSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.wintersportsSnowboardHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.wintersportsSnowboardDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.wintersportsSnowboardMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.wintersportsSnowboardMetaDescription' }),
          }}
          pageName="WintersportsSnowboardSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'wintersports_snowboard'),
    },
    {
      countries: ['cz', 'hu'],
      key: 'camping_accessories',
      path: intl.formatMessage({ id: 'urls.campingAccessoriesRent' }),
      name: 'CampingAccessoriesSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.campingAccessoriesHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.campingAccessoriesDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.campingAccessoriesMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.campingAccessoriesMetaDescription' }),
          }}
          pageName="CampingAccessoriesSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'camping_accessories'),
    },
    {
      countries: [],
      key: 'watersports_lifejacket',
      path: intl.formatMessage({ id: 'urls.watersportsLifejacketRent' }),
      name: 'WatersportsLifejacketSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.watersportsLifejacketHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.watersportsLifejacketDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.watersportsLifejacketMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.watersportsLifejacketMetaDescription' }),
          }}
          pageName="WatersportsLifejacketSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'watersports_lifejacket'),
    },
    {
      countries: ['pl', 'cz', 'sk', 'hu', 'lt'],
      key: 'camping_tent',
      path: intl.formatMessage({ id: 'urls.campingTentRent' }),
      name: 'CampingTentSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.campingTentHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.campingTentDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.campingTentMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.campingTentMetaDescription' }),
          }}
          pageName="CampingTentSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'camping_tent'),
    },
    {
      countries: ['cz'],
      key: 'camping_rooftent',
      path: intl.formatMessage({ id: 'urls.campingRoofTentRent' }),
      name: 'CampingRoofTentSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.campingRoofTentHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.campingRoofTentDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.campingRoofTentMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.campingRoofTentMetaDescription' }),
          }}
          pageName="CampingRoofTentSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'camping_rooftent'),
    },
    {
      countries: ['pl', 'cz', 'hu', 'lt'],
      key: 'bikes_mountain',
      path: intl.formatMessage({ id: 'urls.bikesMountainRent' }),
      name: 'MountainBikesSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.bikesMountainHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.bikesMountainDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.bikesMountainMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.bikesMountainMetaDescription' }),
          }}
          pageName="MountainBikesSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'bikes_mountain'),
    },
    {
      countries: ['pl', 'cz', 'sk'],
      key: 'tourism_carrier',
      path: intl.formatMessage({ id: 'urls.tourismCarrierRent' }),
      name: 'TourismCarrierSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.tourismCarrierHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.tourismCarrierDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.tourismCarrierMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.tourismCarrierMetaDescription' }),
          }}
          pageName="TourismCarrierSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'tourism_carrier'),
    },
    // {
    //   countries: ['pl', 'cz', 'sk'],
    //   key: 'bikes_electric',
    //   path: intl.formatMessage({ id: 'urls.bikesElectricRent' }),
    //   name: 'BikesElectricSearchPage',
    //   component: props => (
    //     <SearchPage
    //       categoryConfig={{
    //         header: intl.formatMessage({ id: 'SearchPage.bikesElectricHeader' }),
    //         description: intl.formatMessage({ id: 'SearchPage.bikesElectricDescription' }),
    //         metaTitle: intl.formatMessage({ id: 'SearchPage.bikesElectricMetaTitle' }),
    //         metaDescription: intl.formatMessage({ id: 'SearchPage.bikesElectricMetaDescription' }),
    //       }}
    //       pageName="BikesElectricSearchPage"
    //       {...props}
    //     />
    //   ),
    //   loadData: (params, search) =>
    //     SearchPage.loadData(params, search, 'bikes_electric'),
    // },
    {
      countries: ['pl', 'cz', 'sk', 'hu', 'lt'],
      key: 'watersports_sup',
      path: intl.formatMessage({ id: 'urls.watersportsSupRent' }),
      name: 'WatersportsSupSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.watersportsSupHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.watersportsSupDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.watersportsSupMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.watersportsSupMetaDescription' }),
          }}
          pageName="WatersportsSupSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'watersports_sup'),
    },
    // {
    //   countries: [],
    //   key: 'bikes_gravel',
    //   path: intl.formatMessage({ id: 'urls.bikesGravelRent' }),
    //   name: 'BikesGravelSearchPage',
    //   component: props => (
    //     <SearchPage
    //       categoryConfig={{
    //         header: intl.formatMessage({ id: 'SearchPage.bikesGravelHeader' }),
    //         description: intl.formatMessage({ id: 'SearchPage.bikesGravelDescription' }),
    //         metaTitle: intl.formatMessage({ id: 'SearchPage.bikesGravelMetaTitle' }),
    //         metaDescription: intl.formatMessage({ id: 'SearchPage.bikesGravelMetaDescription' }),
    //       }}
    //       pageName="BikesGravelSearchPage"
    //       {...props}
    //     />
    //   ),
    //   loadData: (params, search) =>
    //     SearchPage.loadData(params, search, 'bikes_gravel'),
    // },
    {
      countries: [],
      key: 'tourism_sticks',
      path: intl.formatMessage({ id: 'urls.tourismSticksRent' }),
      name: 'TourismSticksSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.tourismSticksHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.tourismSticksDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.tourismSticksMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.tourismSticksMetaDescription' }),
          }}
          pageName="TourismSticksSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'tourism_sticks'),
    },
    {
      countries: ['pl'],
      key: 'bikes_road',
      path: intl.formatMessage({ id: 'urls.bikesRoadRent' }),
      name: 'BikesRoadSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.bikesRoadHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.bikesRoadDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.bikesRoadMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.bikesRoadMetaDescription' }),
          }}
          pageName="BikesRoadSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'bikes_road'),
    },
    {
      countries: ['pl'],
      key: 'tourism_axe',
      path: intl.formatMessage({ id: 'urls.tourismAxeRent' }),
      name: 'TourismAxeSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.tourismAxeHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.tourismAxeDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.tourismAxeMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.tourismAxeMetaDescription' }),
          }}
          pageName="TourismAxeSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'tourism_axe'),
    },
    {
      countries: ['pl', 'cz'],
      key: 'bikes_treadmill',
      path: intl.formatMessage({ id: 'urls.bikesTreadmillRent' }),
      name: 'BikesTreadmillSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.bikesTreadmillHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.bikesTreadmillDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.bikesTreadmillMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.bikesTreadmillMetaDescription' }),
          }}
          pageName="BikesTreadmillSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'bikes_treadmill'),
    },
    {
      countries: ['pl', 'cz'],
      key: 'tourism_snowshoes',
      path: intl.formatMessage({ id: 'urls.tourismSnowshoesRent' }),
      name: 'TourismSnowshoesSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.tourismSnowshoesHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.tourismSnowshoesDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.tourismSnowshoesMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.tourismSnowshoesMetaDescription' }),
          }}
          pageName="TourismSnowshoesSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'tourism_snowshoes'),
    },
    {
      countries: ['pl'],
      key: 'bikes_seat',
      path: intl.formatMessage({ id: 'urls.bikesSeatRent' }),
      name: 'BikesSeatSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.bikesSeatHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.bikesSeatDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.bikesSeatMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.bikesSeatMetaDescription' }),
          }}
          pageName="BikesSeatSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'bikes_seat'),
    },
    {
      countries: ['pl'],
      key: 'transport_bikes',
      path: intl.formatMessage({ id: 'urls.transportBikesRent' }),
      name: 'TransportBikesSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.transportBikesHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.transportBikesDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.transportBikesMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.transportBikesMetaDescription' }),
          }}
          pageName="TransportBikesSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'transport_bikes'),
    },
    {
      countries: ['pl', 'cz'],
      key: 'wintersports_crosscountry',
      path: intl.formatMessage({ id: 'urls.wintersportsCrosscountryRent' }),
      name: 'WintersportsCrosscountrySearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.wintersportsCrosscountryHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.wintersportsCrosscountryDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.wintersportsCrosscountryMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.wintersportsCrosscountryMetaDescription' }),
          }}
          pageName="WintersportsCrosscountrySearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'wintersports_crosscountry'),
    },
    {
      countries: ['pl', 'cz'],
      key: 'bikes_trailer',
      path: intl.formatMessage({ id: 'urls.bikesTrailerRent' }),
      name: 'BikesTrailerSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.bikesTrailerHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.bikesTrailerDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.bikesTrailerMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.bikesTrailerMetaDescription' }),
          }}
          pageName="BikesTrailerSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'bikes_trailer'),
    },
    {
      countries: [],
      key: 'bikes_city',
      path: intl.formatMessage({ id: 'urls.bikesCityRent' }),
      name: 'BikesCitySearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.bikesCityHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.bikesCityDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.bikesCityMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.bikesCityMetaDescription' }),
          }}
          pageName="BikesCitySearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'bikes_city'),
    },
    {
      countries: ['pl', 'cz', 'hu', 'lt'],
      key: 'watersports_kayak',
      path: intl.formatMessage({ id: 'urls.watersportsKayakRent' }),
      name: 'WatersportsKayakSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.watersportsKayakHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.watersportsKayakDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.watersportsKayakMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.watersportsKayakMetaDescription' }),
          }}
          pageName="WatersportsKayakSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'watersports_kayak'),
    },
    {
      countries: ['cz', 'sk'],
      key: 'watersports_accessories',
      path: intl.formatMessage({ id: 'urls.watersportsAccessoriesRent' }),
      name: 'WatersportsAccessoriesSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.watersportsAccessoriesHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.watersportsAccessoriesDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.watersportsAccessoriesMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.watersportsAccessoriesMetaDescription' }),
          }}
          pageName="WatersportsAccessoriesSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'watersports_accessories'),
    },
    {
      countries: ['cz', 'sk'],
      key: 'fitness_cardio',
      path: intl.formatMessage({ id: 'urls.fitnessCardioRent' }),
      name: 'FitnessCardioSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.fitnessCardioHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.fitnessCardioDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.fitnessCardioMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.fitnessCardioMetaDescription' }),
          }}
          pageName="FitnessCardioSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'fitness_cardio'),
    },
    {
      countries: [],
      key: 'bikes_accessories',
      path: intl.formatMessage({ id: 'urls.bikesAccessoriesRent' }),
      name: 'BikesAccessoriesSearchPage',
      component: props => (
        <SearchPage
          categoryConfig={{
            header: intl.formatMessage({ id: 'SearchPage.bikesAccessoriesHeader' }),
            description: intl.formatMessage({ id: 'SearchPage.bikesAccessoriesDescription' }),
            metaTitle: intl.formatMessage({ id: 'SearchPage.bikesAccessoriesMetaTitle' }),
            metaDescription: intl.formatMessage({ id: 'SearchPage.bikesAccessoriesMetaDescription' }),
          }}
          pageName="BikesAccessoriesSearchPage"
          {...props}
        />
      ),
      loadData: (params, search) =>
        SearchPage.loadData(params, search, 'bikes_accessories'),
    }
  ];
};

export default categoryRoutesConfiguration;
